import React from 'react'

type FlavourSwatchType = React.SVGProps<SVGSVGElement>

const FlavourSwatch: React.FC<FlavourSwatchType> = (props) => {
    return (
        <svg
            width="35"
            height="48"
            viewBox="0 0 32 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M31.6839 20.135C31.6839 28.897 24.7071 36 16.1008 36C7.49446 36 0.517652 28.897 0.517652 20.135C0.285074 15.1624 2.37833 11.6106 5.16934 7.8219C7.72777 4.98041 12.3795 -0.228986 16.1008 0.00780325C20.0547 -0.228986 25.4042 5.97665 26.7997 7.69675C29.5907 11.137 31.9165 15.636 31.6839 20.135Z"
                fill="#BDBCBB"
            />
        </svg>
    )
}

export default FlavourSwatch
